import React from 'react'
import PropTypes from 'prop-types'
import {
    Box,
    Text,
    Button,
    Divider,
    Stack
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {FormattedMessage} from 'react-intl'
import {OrderDate} from './order-status'

// CONSTANTS
const TRANSIT_STATUS = 'In Transit'
const SHIPPED_STATUS = 'Shipped'

export const OrderTracking = ({order}) => {
    const packages = order.packages

    const getButtonVariant = (status) => {
        return status === TRANSIT_STATUS || status === SHIPPED_STATUS ? 'solid' : 'outline'
    }

    const isMultiplePackages = order.packages.length > 1

    return (
        <>
            <Stack spacing={8} alignItems="flex-start" mb={8}>
                {packages.map((pkg, index) => (
                    <Box key={pkg.trackingNumber || index} w="full">
                        <Text fontSize="md" fontWeight={700} textTransform="uppercase" mb={4}>
                            {isMultiplePackages ? (
                                <FormattedMessage
                                    defaultMessage="Package {packageNumber} Status: {status}"
                                    id="account_order_detail.label.package_status_multiple"
                                    values={{
                                        packageNumber: index + 1,
                                        status: pkg.status
                                    }}
                                />
                            ) : (
                                <FormattedMessage
                                    defaultMessage="Status: {status}"
                                    id="account_order_detail.label.package_status_single"
                                    values={{status: pkg.status}}
                                />
                            )}
                        </Text>

                        {pkg.trackingURL && (
                            <Button
                                as="a"
                                href={pkg.trackingURL}
                                target="_blank"
                                rel="noopener noreferrer"
                                variant={getButtonVariant(pkg.status)}
                                size="lg"
                                width="100%"
                                maxW="340px"
                            >
                                {isMultiplePackages ? (
                                    <FormattedMessage
                                        defaultMessage="Track Package {packageNumber}/{totalPackages}"
                                        id="account_order_detail.label.track_package_multiple"
                                        values={{
                                            packageNumber: index + 1,
                                            totalPackages: order.packages.length
                                        }}
                                    />
                                ) : (
                                    <FormattedMessage
                                        defaultMessage="Track Package"
                                        id="account_order_detail.label.track_package_single"
                                    />
                                )}
                            </Button>
                        )}
                    </Box>
                ))}
            </Stack>
            <OrderDate order={order} />
        </>
    )
}

OrderTracking.propTypes = {
    order: PropTypes.shape({
        packages: PropTypes.arrayOf(
            PropTypes.shape({
                trackingNumber: PropTypes.string,
                status: PropTypes.string,
                trackingURL: PropTypes.string
            })
        ).isRequired,
        orderDate: PropTypes.string,
        shippingMethod: PropTypes.string
    }).isRequired
}
